import { css } from 'aphrodite';
import { NavLink, useHistory, useParams } from 'react-router-dom';
import { EditAutomationTemplate } from '.';
import { IImpersonationContext } from '../../../extViewmodels';
import { MastheadPortalId } from '../../../models/AdminModels';
import { useAdminAccountQuery, useAutomationTemplateIdQuery } from '../../../queries';
import {
	Breadcrumb,
	BreadcrumbItem,
	BreadcrumbLink,
	BreadcrumbList,
	BreadcrumbPage,
	BreadcrumbSeparator,
} from '../../components/Breadcrumb';
import { MultiContainerHeader } from '../../components/MultiContainerHeader';
import { baseStyleSheet } from '../../styles/styles';

export function AdminAccountEditAutomationTemplate() {
	const params = useParams<{ accountId: string; id: string }>();
	const impersonationContext: IImpersonationContext = { account: { id: params.accountId } };
	const accountQuery = useAdminAccountQuery({ accountId: params.accountId });
	const automationTemplateQuery = useAutomationTemplateIdQuery({ id: params.id, impersonationContext });
	const companyName = accountQuery.data?.companyName;
	const automationTemplateName = automationTemplateQuery.data?.name;
	const history = useHistory();

	return (
		<>
			<MultiContainerHeader
				appBarHeader={
					<div className={css(baseStyleSheet.horizontalStack)} style={{ alignItems: 'center', gap: '16px' }}>
						<Breadcrumb>
							<BreadcrumbList>
								<BreadcrumbItem>
									<BreadcrumbLink asChild>
										<NavLink to='/accounts'>Accounts</NavLink>
									</BreadcrumbLink>
								</BreadcrumbItem>
								<BreadcrumbSeparator />
								<BreadcrumbItem>
									<BreadcrumbLink asChild>
										<NavLink to={`/accounts/${params.accountId}?tab=Automations`}>
											{companyName ?? 'Loading...'}
										</NavLink>
									</BreadcrumbLink>
								</BreadcrumbItem>
								<BreadcrumbSeparator />
								<BreadcrumbItem>
									<BreadcrumbPage>{`Automation "${automationTemplateName ?? '...'}"`}</BreadcrumbPage>
								</BreadcrumbItem>
							</BreadcrumbList>
						</Breadcrumb>
						<NavLink
							to={`/accounts/${params.accountId}/automations/${params.id}/test`}
							className={css(baseStyleSheet.brandLink)}
						>
							Preview
						</NavLink>
					</div>
				}
				appBarPortalDestinationId={MastheadPortalId}
			/>
			<EditAutomationTemplate
				impersonationContext={impersonationContext}
				onAutomationDeleted={() => history.replace(`/accounts/${params.accountId}?tab=Automations`)}
				onAutomationPublished={() => history.push(`/accounts/${params.accountId}?tab=Automations`)}
				onAutomationDisabled={() => history.push(`/accounts/${params.accountId}?tab=Automations`)}
			/>
		</>
	);
}
